// extracted by mini-css-extract-plugin
export default {"cardStyles":"RecordCard_cardStyles__PTCTA","pStyles":"RecordCard_pStyles__0sCVl","formStyles":"RecordCard_formStyles__btGTw"};